import { useQuery } from '@tanstack/react-query';

import { formatData } from 'components/helpers/reactQuery';

export function useAcceptedReviewQuery({ reviewId }) {
  return useQuery({
    queryKey: ['acceptedReviews', reviewId],
    queryFn: async () => {
      const response = await axios.get(`/accepted_reviews/${reviewId}`);

      return response.data;
    },
    select: (data) =>
      formatData({
        data,
        resourceTypes: [
          'personnel',
          'photo',
          'profilePhoto',
          'projectPersonnel',
          'signature',
          'version',
        ],
      }),
  });
}
